import BusinessProfile from './BusinessProfile';

export default BusinessProfile;